export const DIALOG_VERSION = '1.0.2';
export const DIALOG_VERSION_KEY = 'adminuiDialogVersion';